import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'

import { apolloService } from '../../common/services'

import { DICTIONARY_WORDS_QUERY } from '../graphql/queries'
import { FETCH_DICTIONARY_WORDS } from '../redux/action-types'

const useDictionaryWordsQuery = (
  type,
  searchValue,
  languageIds,
  page,
  pageSize,
) => {
  const dispatch = useDispatch()

  const { isLoading, error, data } = useSelector(store =>
    get(store.dictionaryWords.data, type?.fieldName, { data: {} }),
  )

  const refetch = useCallback(
    (type, searchValue, languageIds, page, pageSize) =>
      apolloService.query(
        DICTIONARY_WORDS_QUERY,
        {
          filters: { type: type?.value, searchValue, languageIds },
          page,
          pageSize,
        },
        dispatch,
        FETCH_DICTIONARY_WORDS,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch(type, searchValue, languageIds, page, pageSize)
  }, [type, searchValue, languageIds, page, pageSize, refetch])

  return { isLoading, error, data }
}

export default useDictionaryWordsQuery
